"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "version",
                type: "bytes32",
            },
        ],
        name: "CreateQuery",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "StartIndexing",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "StopIndexing",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "blockheight",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "mmrRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "UpdateDeploymentStatus",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "UpdateIndexingStatusToReady",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "version",
                type: "bytes32",
            },
        ],
        name: "UpdateQueryDeployment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "UpdateQueryMetadata",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
        ],
        name: "addCreator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "version",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "createQueryProject",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "creatorRestricted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "creatorWhitelist",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "deploymentStatusByIndexer",
        outputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "blockHeight",
                type: "uint256",
            },
            {
                internalType: "enum IndexingServiceStatus",
                name: "status",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "isIndexingAvailable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "isOffline",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextQueryId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numberOfIndexingDeployments",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "queryInfos",
        outputs: [
            {
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "latestVersion",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "latestDeploymentId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
        ],
        name: "removeCreator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "blockheight",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "mmrRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "reportIndexingStatus",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_creatorRestricted",
                type: "bool",
            },
        ],
        name: "setCreatorRestricted",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offlineCalcThreshold",
                type: "uint256",
            },
        ],
        name: "setOfflineCalcThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
        ],
        name: "setSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "startIndexing",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "stopIndexing",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "version",
                type: "bytes32",
            },
        ],
        name: "updateDeployment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "updateIndexingStatusToReady",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "queryId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "updateQueryProjectMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class QueryRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "QueryRegistry";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.QueryRegistry__factory = QueryRegistry__factory;
QueryRegistry__factory.bytecode = _bytecode;
QueryRegistry__factory.abi = _abi;
